import CityPageTemplate from "../hawaii-city/CityPageTemplate";
import { kauaiConfig } from "./data";

export default function Page() {
  return <CityPageTemplate config={kauaiConfig} />;
}